//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      rowStyleOption: {
        stripe: true,
      },
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {
          return "table-body-cell-class";
        },
      },
      columns: [
        {
          field: "name",
          key: "a",
          title: "项目",
          align: "left",
          width: "50%",
        },
        {
          field: "date",
          key: "b",
          title: "本期金额",
          width: "25%",
          align: "right",
        },
        {
          field: "hobby",
          key: "c",
          title: "本年累计",
          width: "25%",
          align: "right",
        },
      ],
      tableData: [
        {
          name: "一、主营业务收入",
          date: "5,468,362.22",
          hobby: "45,323,469.34",
        },
      ],
    };
  },
};
